// extracted by mini-css-extract-plugin
module.exports = {"nprogress":"nprogress","bar":"bar","peg":"peg","nprogress-custom-parent":"nprogress-custom-parent"};